import { render, staticRenderFns } from "./OrdersFromShopify.vue?vue&type=template&id=3f455d62&scoped=true&"
import script from "./OrdersFromShopify.vue?vue&type=script&lang=ts&"
export * from "./OrdersFromShopify.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f455d62",
  null
  
)

export default component.exports